import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const ReportPartByVehicleList = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportPartByVehicleDashboard/ReportPartByVehicleList"
    )
);

export const ReportPartByVehicle = () => {
  return (
    <Layout>
      <ReportPartByVehicleList />
    </Layout>
  );
};
